export function getEGiftCardTotalPages(total: number, size: number): number {
  if (!size || size <= 0) return 0;
  if (!total || total <= 0) return 0;
  return Math.ceil(total / size);
}
